import { Alert, Stack } from "@mui/material";
import { Download, School } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import API from "../../../services/API";
import ConfettiExplosion from "react-confetti-explosion";
import { txt } from "../../../services/translation";

export default function Certificate({enrollment}){

    const [loading, setLoading] = useState(false)

    const handleClick = () => {

        setLoading(true)

        API.download(`/study/enrollments/${enrollment?.id}/diploma/doc.pdf`)
            .finally(() => setLoading(false))
    }

    if(!enrollment?.completed){

        return <Alert severity='info'>
            {txt('certificateInfo')}
        </Alert>
    
    }

    return <Stack alignItems='center' spacing={1} sx={{py: 3}}>

        <ConfettiExplosion />

        <Alert severity='success' icon={<School />}>
            {txt('congratulationsMessage')}
        </Alert>

        <LoadingButton
            loading={loading}
            onClick={handleClick}
            startIcon={<Download />}
        >
            {txt('downloadCertificate')}
        </LoadingButton>

    </Stack>

}